import { type QueryClient } from '@tanstack/react-query';

import { type OpzlyExperimentName } from '../config';
import { type CachedExperiments } from '../types';

import { RQ_PREVIEW_EXPS_CACHE } from '@/modules/ReactQuery/cacheKeys';

/**
 * Updates the bucketed flag for experiments in the cache
 */
export function updateExperimentsBucketedFlag(
  queryClient: QueryClient,
  experimentNames: OpzlyExperimentName[],
  bucketed: boolean
): void {
  queryClient.setQueryData(
    [RQ_PREVIEW_EXPS_CACHE],
    (cached: CachedExperiments | undefined) => {
      const updateableCopy = { ...cached };

      for (const exp of experimentNames) {
        if (updateableCopy[exp]) {
          updateableCopy[exp].bucketed = bucketed;
        }
      }

      return updateableCopy;
    }
  );
}
